import tw from "twin.macro";

export const Cardv1MapSection = tw.section`w-full px-[9.875rem] pb-[9.875rem] space-y-[5.625rem]`